
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.831 16C31.831 7.485 24.516.169 16 .169S.169 7.484.169 16c0 8.515 7.317 15.831 15.831 15.831S31.831 24.516 31.831 16zm-4.558 7.436c-2.398 3.718-6.595 5.996-11.273 5.996s-8.754-2.279-11.153-5.996L16 18.879l11.273 4.557zM4.127 22.237C3.048 20.438 2.568 18.279 2.568 16c0-3.478 1.2-6.595 3.718-9.234 2.519-2.639 5.636-4.078 9.114-4.197l-1.679 12.113-9.594 7.555zM29.432 16c-.014 2.336-.493 4.342-1.439 6.116l-9.474-7.435L16.72 2.568c3.478.12 6.476 1.559 8.995 4.197 2.518 2.64 3.718 5.758 3.718 9.235z","fill":"currentColor"}})])
          )
        }
      }
    